import { useContext } from 'react';
import AppContext from '../../AppContext';
import { UserPhoto } from '../../shared/User';
import Wizard from '../../Wizard';
import HowToGetPremium from '../../shared/Premium/HowToGetPremium';
import Notifications from '../Notifications';
import { LogInButton } from '../LogInButton';
import { AccountDropdownMenu } from './AccountDropdownMenu';
import { TopRightMenuItem } from './TopRightMenuItem';

export const TopRightMenu = () => {
  const { logout, user } = useContext(AppContext);
  if (user) {
    return (
      <div className="float-end">
        {!user.isPremium && (
          <TopRightMenuItem>
            <HowToGetPremium />
          </TopRightMenuItem>
        )}
        <TopRightMenuItem>
          <Wizard icon={true} />
        </TopRightMenuItem>
        <TopRightMenuItem>
          <Notifications />
        </TopRightMenuItem>
        <TopRightMenuItem>
          <UserPhoto uid={user.uid} />
        </TopRightMenuItem>
        <TopRightMenuItem>
          <AccountDropdownMenu logout={logout} />
        </TopRightMenuItem>
      </div>
    );
  }
  return (
    <TopRightMenuItem>
      <LogInButton />
    </TopRightMenuItem>
  );
};
